import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAnyModalOpen } from './useModalDialog';

const isTypingTarget = (el) => {
  if (!el) return false;
  const tag = el.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable;
};

/**
 * Alt+1 through Alt+9 jump directly to the Nth path in `paths` (1-indexed,
 * matching the nav bar's visible left-to-right order). Designed for AAC
 * switch-scanning software (Mind Express 5, Grid 3) to drive via a
 * modifier+key chord, chosen specifically so it never collides with the
 * existing bare 1-9 per-page AacButton shortcuts.
 */
export function useGlobalNavShortcuts(paths) {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!event.altKey) return;
      if (isAnyModalOpen()) return;
      if (isTypingTarget(document.activeElement)) return;

      const index = Number(event.key) - 1;
      if (Number.isInteger(index) && index >= 0 && index < paths.length) {
        event.preventDefault();
        navigate(paths[index]);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [paths, navigate]);
}
